import { LandingContext } from '../../Components/Profile/LandingContext'; 
import PrivateHeader from '../../Common/Layout/PrivateHeader';
import B2CFooter from './B2CFooter';
import B2CTopHeader from './B2CTopHeader';
import { Outlet, Navigate } from 'react-router-dom'; 
import { useAuth } from '../../Common/Configurations/AuthContext';

const B2CLayout = () => {
    const { user, loading, landingData } = useAuth(); // ⬅ Get loading state

    if (loading) {
        // ⏳ Wait for AuthContext to finish refreshing user
        return <div>Loading...</div>; // Or use a loader/spinner
    }

    if (!user) {
        // ⛔ Now safe to redirect if user is still null
        return <Navigate to="/" replace />;
    }

    return (
        <LandingContext.Provider value={landingData}>
            <div className="b2c-wrapper">
                <B2CTopHeader value={landingData} />
                <PrivateHeader value={landingData} />
                <main className="main-content">
                    <Outlet />
                </main>
                <B2CFooter value={landingData} />
            </div>
        </LandingContext.Provider>
    );
};

export default B2CLayout;